import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import { REACT_SELECT_FAIL_FALLBACK_OPTIONS } from "components/ProjectSpecificComponents/Constants/GLOBAL_CONSTANTS"
import {
	TPickList,
	TPickListInfo,
} from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import {
	isReactSelectOptionArray,
	isReactSelectSingleOption,
	TReactSelectOption,
} from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"
import { observer } from "mobx-react-lite"
import React, { useEffect, useMemo, useState } from "react"
import Select from "../../Global/atoms/Select"

interface Props {
	valueKey: string | undefined
	value: readonly TReactSelectOption[] | undefined
	isMultiSelect: boolean
	onChangeValue: (
		value: string | readonly TReactSelectOption[],
		customKey?: string | undefined
	) => void
	picklistId: string | null | undefined
	excludedOptions: TReactSelectOption[]
}

const UserSideNewRequestPickList = observer(
	({
		valueKey,
		value,
		picklistId,
		isMultiSelect,
		onChangeValue,
		excludedOptions,
	}: Props) => {
		const [loadingData, setLoadingData] = useState<boolean>(false)
		const [picklistOptions, setPicklistOptions] = useState<TPickList[]>([])

		const filteredOptions: TPickList[] = useMemo(() => {
			if (excludedOptions.length === 0) return picklistOptions
			
			const arr = picklistOptions.filter(({ value: picklist }) => {
				for (let data of excludedOptions) {
					return data.value !== picklist
				}
			})

			return arr ?? REACT_SELECT_FAIL_FALLBACK_OPTIONS
		}, [picklistOptions])

		useEffect(() => {
			const searchPickListOptions = async () => {
				setLoadingData(true)
				if (!picklistId) return

				const { ok, data } = await AppRequests("Requests").get<TPickListInfo>("picklist", {
					id: picklistId,
				})

				if (ok && data) {
					setPicklistOptions(data.picklistValues)
				}

				setLoadingData(false)
			}

			searchPickListOptions()
		}, [])

		return (
			<Select
				valueKey={valueKey}
				placeholder=""
				value={value}
				options={filteredOptions}
				isLoading={loadingData}
				isMulti={isMultiSelect}
				onChange={(selectedOptions) => {
					if (isReactSelectSingleOption(selectedOptions)) {
						// For Single pick-list
						onChangeValue(selectedOptions.value)
					} else if (isReactSelectOptionArray(selectedOptions)) {
						// For Multi pick-list
						onChangeValue(selectedOptions)
					} else {
						// To clear field if no value is selected
						onChangeValue("")
					}
				}}
			/>
		)
	}
)

export default UserSideNewRequestPickList
